import axios from "axios";
export function extractAxiosErrorMessage(error, fallback = "An unexpected error occurred.") {
    if (axios.isAxiosError(error)) {
        const data = error.response?.data;
        // 1. Try "detail" (FastAPI standard)
        if (data && typeof data === "object") {
            const obj = data;
            if (typeof obj.detail === "string")
                return obj.detail;
            if (typeof obj.message === "string")
                return obj.message;
            if (typeof obj.error === "string")
                return obj.error;
            // 2. Handle Pydantic array details (simplified)
            if (Array.isArray(obj.detail)) {
                const first = obj.detail[0];
                if (first && typeof first.msg === "string") {
                    return first.msg;
                }
            }
        }
        // 3. Fallback to status message
        if (error.response?.statusText) {
            return `Request failed: ${error.response.statusText}`;
        }
        // 4. Fallback to axios message
        if (error.message) {
            return error.message;
        }
    }
    if (error instanceof Error) {
        return error.message;
    }
    return fallback;
}
